import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";

// Definir tipos TypeScript para mejor tipado
interface CategoryData {
  id: string;
  image: string;
  name: string;
  description: string;
  color: string;
  link: string;
  icon?: string;
}

interface CategoryProps {
  category: CategoryData;
  index: number;
}

const cat_data: CategoryData[] = [
  {
    id: "maltas",
    image: "/images/home/cat_1.jpg",
    name: "Maltas",
    description: "Ingredientes base para tu cerveza",
    color: "yellow",
    link: "/productos/Maltas",
    icon: "🌾"
  },
  {
    id: "lupulos",
    image: "/images/home/cat_2.jpg",
    name: "Lúpulos",
    description: "Aromas y sabores únicos",
    color: "orange",
    link: "/productos/Lupulos",
    icon: "🍺"
  },
  {
    id: "levaduras",
    image: "/images/home/cat_3.jpg",
    name: "Levaduras",
    description: "Fermentación perfecta",
    color: "blue",
    link: "/productos/Levaduras",
    icon: "🧬"
  },
  {
    id: "outlet",
    image: "/images/home/cat_4.jpg",
    name: "OUTLET",
    description: "Ofertas especiales",
    color: "light-gray",
    link: "/productos/Outlet",
    icon: "🏷️"
  },
];

const Categories: React.FC = () => {
  return (
    <section className="categories py-5">
      <Container>
        <div className="text-center mb-5">
          <h2 className="display-4 fw-bold text-dark mb-3">
            Cerveza de Calidad
          </h2>
          <p className="lead text-muted">
            Descubre los mejores ingredientes para tu cerveza artesanal
          </p>
        </div>
        <Row className="g-4">
          {cat_data.map((category, index) => (
            <Category
              key={category.id}
              category={category}
              index={index}
            />
          ))}
        </Row>
      </Container>
    </section>
  );
};

const Category: React.FC<CategoryProps> = ({ category, index }) => {
  const { image, name, description, color, link, icon } = category;

  return (
    <Col lg={3} md={6} xs={6} className="mb-4">
      <Link 
        to={link} 
        className="text-decoration-none"
        style={{ display: 'block' }}
      >
        <div 
          className="category-card h-100 position-relative overflow-hidden rounded-4 shadow-sm border-0"
          style={{
            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
            cursor: 'pointer'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = 'translateY(-8px)';
            e.currentTarget.style.boxShadow = '0 20px 40px rgba(0,0,0,0.1)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.boxShadow = '0 4px 20px rgba(0,0,0,0.08)';
          }}
        >
          {/* Imagen de fondo con overlay */}
          <div 
            className="position-relative"
            style={{ 
              height: '200px',
              backgroundImage: `url(${image})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat'
            }}
          >
            <div 
              className="position-absolute top-0 start-0 w-100 h-100"
              style={{
                background: `linear-gradient(135deg, rgba(0,0,0,0.3) 0%, rgba(0,0,0,0.1) 100%)`
              }}
            />
            
            {/* Icono */}
            <div className="position-absolute top-0 end-0 p-3">
              <span 
                className="fs-1 opacity-75"
                style={{ filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.3))' }}
              >
                {icon}
              </span>
            </div>
          </div>

          {/* Contenido */}
          <div className="p-4">
            <div className="d-flex align-items-center justify-content-between mb-2">
              <h4 className="fw-bold text-dark mb-0">{name}</h4>
              <div 
                className={`color-badge rounded-pill ${color}`}
                style={{ 
                  width: '12px', 
                  height: '12px',
                  backgroundColor: color === 'yellow' ? '#ffc107' : 
                                 color === 'orange' ? '#fd7e14' :
                                 color === 'blue' ? '#0d6efd' : '#6c757d'
                }}
              />
            </div>
            <p className="text-muted small mb-3">{description}</p>
            
            {/* Botón de acción */}
            <div className="d-flex align-items-center text-primary fw-semibold">
              <span className="me-2">Explorar</span>
              <svg 
                width="16" 
                height="16" 
                fill="currentColor" 
                viewBox="0 0 16 16"
                style={{ transition: 'transform 0.2s ease' }}
              >
                <path fillRule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"/>
              </svg>
            </div>
          </div>

          {/* Efecto de brillo en hover */}
          <div 
            className="position-absolute top-0 start-0 w-100 h-100"
            style={{
              background: 'linear-gradient(45deg, transparent 30%, rgba(255,255,255,0.1) 50%, transparent 70%)',
              transform: 'translateX(-100%)',
              transition: 'transform 0.6s ease',
              pointerEvents: 'none'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateX(100%)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateX(-100%)';
            }}
          />
        </div>
      </Link>
    </Col>
  );
};

export default Categories;
